module.exports = __webpack_public_path__ + "static/media/modal-bg.e7858a5f.svg";